module.exports = __webpack_public_path__ + "static/img/logo.de002d7e.svg";